import { render } from "./AuthLayout.vue?vue&type=template&id=ad4e102a"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script